import { render, staticRenderFns } from "./payForDetails.vue?vue&type=template&id=d8142ea6"
import script from "./payForDetails.vue?vue&type=script&lang=js"
export * from "./payForDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports